import {
  DRUG_TEST_CREATED,
  DRUG_TEST_ERROR,
  DRUG_TEST_DELETE,
  DRUG_TEST_UPDATED,
  DRUG_TEST_LIST_UPDATED,
  GET_DRUG_TEST_BY_ID,
  DRUG_TEST_SEARCH_PARAMATERS_UPDATE,
  LOADING_ON_DRUG_TEST_SUBMIT,
  RESET,
  LOAD_PAGE,
  LOADING_DRUG_TEST_LIST_DATA,
} from "actions/types";
import * as Constants from "constants/index";

const initialState = {
  drugTestList: {
    page: 1,
    data: [],
    count: 0,
  },
  currentDrugTest: null,
  loadingDrugTestList: true,
  loadingDrugTest: true,
  loadingDrugTestData: true,
  performDelete: false,
  error: {},
  sortingParams: {
    limit: Constants.DEFAULT_PAGE_SIZE,
    page: 1,
    orderBy: "createdAt",
    ascending: "desc",
    query: "",
    filters: [],
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESET:
      return {
        ...initialState,
        loadingDrugTest: state.loadingDrugTest,
        loadingDrugTestList: state.loadingDrugTestList,
        loadingListData: state.loadingListData,
      };
    case LOAD_PAGE:
      return {
        ...state,
        loadingDrugTest: false,
      };
    case DRUG_TEST_CREATED:
      return {
        ...state,
        loadingDrugTest: false,
      };
    case DRUG_TEST_UPDATED:
      return {
        ...state,
        currentDrugTest: payload,
        sortingParams: initialState.sortingParams,
        loadingDrugTest: false,
      };
    case DRUG_TEST_DELETE:
      const currentCount = state.drugTestList.count;
      const currentLimit = state.sortingParams.limit;
      const currentPage = parseInt(state.drugTestList.page);
      let remainingPages = Math.ceil((currentCount - 1) / currentLimit);
      remainingPages = remainingPages ? remainingPages : 1;
      return {
        ...state,
        drugTestList: {
          data: state.drugTestList.data.filter(
            (drugTest) => drugTest._id !== payload
          ),
          count: currentCount - 1,
          page:
            currentPage <= remainingPages
              ? currentPage.toString()
              : remainingPages.toString(),
        },
        loadingDrugTestList: false,
        performDelete: true,
      };
    case DRUG_TEST_ERROR:
      return {
        ...state,
        error: payload,
        loadingDrugTest: false,
        loadingDrugTestList: false,
        loadingListData: false,
        performDelete: false,
      };
    case GET_DRUG_TEST_BY_ID:
      return {
        ...state,
        currentDrugTest: payload,
        loadingDrugTest: false,
      };
    case DRUG_TEST_LIST_UPDATED:
      return {
        ...state,
        drugTestList: {
          data: payload.data,
          page: payload.metadata[0].current_page,
          count: payload.metadata[0].totalRecord,
        },
        loadingDrugTest: false,
        loadingDrugTestList: false,
        loadingDrugTestData: false,
        performDelete: false,
      };
    case DRUG_TEST_SEARCH_PARAMATERS_UPDATE:
      return {
        ...state,
        sortingParams: { ...payload },
      };
    case LOADING_DRUG_TEST_LIST_DATA:
      return {
        ...state,
        loadingDrugTestData: true,
      };
    case LOADING_ON_DRUG_TEST_SUBMIT:
      return {
        ...state,
        loadingDrugTest: true,
      };
    default:
      return state;
  }
}
